export type ThemeOption = 'original' | 'dark' | '';

export enum Type {
  SET_APP_THEME = 'SET_APP_THEME',
}

export type BaseThemeAction<T> = {
  type: T;
};

export interface SetAppThemeAction {
  type: 'SET_APP_THEME';
  theme: ThemeOption;
}

export interface SetIsOpenThemeSelector {
  type: 'SET_IS_OPEN_THEME_SELECTOR';
  isOpen: boolean;
}

export type ThemeActions = SetAppThemeAction | SetIsOpenThemeSelector;

const setAppTheme = (theme: ThemeOption) => ({
  type: 'SET_APP_THEME',
  theme,
});

const setIsOpenThemeSelector = (isOpen: boolean) => ({
  type: 'SET_IS_OPEN_THEME_SELECTOR',
  isOpen,
});

export const actions = {
  setAppTheme,
  setIsOpenThemeSelector,
};

export type ThemeState = {
  app: ThemeOption;
  isThemeSelectorMenuOpen: boolean;
};

const initialState: ThemeState = {
  app: (localStorage.getItem('LAST_USED_THEME') ?? '') as ThemeOption,
  isThemeSelectorMenuOpen: false,
};

export default (state = initialState, action: ThemeActions): ThemeState => {
  switch (action.type) {
    case 'SET_APP_THEME': {
      const { theme } = action;
      return {
        ...state,
        app: theme,
      };
    }
    case 'SET_IS_OPEN_THEME_SELECTOR': {
      const { isOpen } = action;
      return {
        ...state,
        isThemeSelectorMenuOpen: isOpen,
      };
    }
    default:
      return state;
  }
};
